var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNorth(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 70.41 70.41",
    enableBackground: "new 0 0 70.41 70.41",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_2_00000165953788578087471890000002309821311796668093_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M35.2,0.2c-19.33,0-35,15.67-35,35s15.67,35,35,35s35-15.67,35-35S54.53,0.2,35.2,0.2z M35.82,1.45 C35.82,1.44,35.82,1.44,35.82,1.45c4.35,0.08,8.56,0.96,12.53,2.65c4.02,1.7,7.63,4.14,10.73,7.24s5.54,6.71,7.24,10.73 c1.68,3.97,2.57,8.19,2.65,12.53H35.82V1.45z M4.09,22.06c1.7-4.02,4.14-7.63,7.24-10.73c3.1-3.1,6.71-5.54,10.73-7.24 c3.1-1.31,6.34-2.14,9.68-2.48v32.97H1.44C1.52,30.25,2.41,26.04,4.09,22.06z M11.33,59.08c-3.1-3.1-5.54-6.71-7.24-10.73 c-1.68-3.97-2.57-8.19-2.65-12.53h33.14v33.14c-4.34-0.08-8.55-0.96-12.52-2.65C18.04,64.62,14.43,62.18,11.33,59.08z  M66.32,48.35c-1.7,4.02-4.14,7.63-7.24,10.73c-3.1,3.1-6.71,5.54-10.73,7.24c-3.97,1.68-8.18,2.57-12.53,2.65V35.83h33.14 C68.89,40.16,68,44.37,66.32,48.35z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNorth);
export default __webpack_public_path__ + "static/media/north.ccbde9b276bd4f5e94af9b44c3acfb98.svg";
export { ForwardRef as ReactComponent };